import hmacSHA256 from 'crypto-js/hmac-sha256';

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
    const { $i18n } = useNuxtApp();

    const deviceCookie = useCookie('device_id', {
        default: () => crypto.randomUUID(),
        watch: false,
        maxAge: 60 * 60 * 24 * 365
    });

    const $api = $fetch.create({
        baseURL: (config.public.apiBase as string),
        credentials: 'include',
        onRequest({ options }) {
            const hmacSecret = config.public.apiHmacSecret as string;
            const apiClientKey = config.public.apiClientKey as string;

            const newHeaders = new Headers(options.headers);

            // 1. CHECK IF THE BODY IS FORMDATA
            const isFormData = options.body instanceof FormData;

            // 2. ONLY set JSON content type if it's NOT FormData
            if (!isFormData) {
                newHeaders.set('Content-Type', 'application/json');
            }

            newHeaders.set('x-api-key', apiClientKey);
            newHeaders.set('Accept-Language', $i18n.locale.value || 'hy');
            newHeaders.set('x-device-id', deviceCookie.value || 'web-client');

            // 3. ONLY try to sign if it's an object and NOT FormData
            if (options.body && typeof options.body === 'object' && !isFormData) {
                const bodyString = JSON.stringify(options.body);
                const hash = hmacSHA256(bodyString, hmacSecret).toString();
                newHeaders.set('x-signature', hash);
            }

            options.headers = newHeaders;
        },
    });

    return {
        provide: {
            api: $api
        }
    };
});